import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Box from "../Common/Box";
import PersonAdd from "@mui/icons-material/PersonAdd";
import utils, {createInviteLink} from "../lib/utils";
import {notifier} from "../lib/Notifier";
import Input from "../Common/Input";
import {TransitionProps} from "@mui/material/transitions/transition";
import shadowClient from "../lib/clients/shadow/shadowClient";
import {APIUser} from "../lib/clients/shadow/interfaces";

interface AnonUserDialogProps {
    room: any, // Adjust the type based on what `room` should be
    open: boolean,
    onClose?: () => void,
}

interface Options {
    username: string,
}


const Transition: React.JSXElementConstructor<
        TransitionProps & { children: React.ReactElement<any, any> }
> = React.forwardRef<unknown, React.PropsWithChildren<{}>>(
        function Transition(props, ref) {
            // @ts-ignore
            return <Slide direction="up" ref={ref} {...props} />;
        });

export default function AnonUserDialog({room, open, onClose}: AnonUserDialogProps) {
    const [options, setOptions] = useState<Options>({username: ""});
    const [user, setUser] = useState<APIUser>();
    const [errorText, setErrortext] = useState<string>("");
    const {
        username,
    } = options;

    return <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => {
                setUser(undefined);
                setOptions({username: ""});
                setErrortext("");

                if (onClose) {
                    onClose();
                }
            }}
    >
        <DialogTitle>{"Invite new user"}</DialogTitle>
        <DialogContent
                sx={{
                    paddingBottom: 0,
                }}
        >
            <Box column paddingTop={"5px"}>
                <Input
                        sx={{
                            marginBottom: 0,
                        }}
                        label={"Username:"}
                        type={"text"}
                        inputKey={'username'}
                        value={username}
                        onChange={kvPair => {
                            setOptions({
                                ...options,
                                ...kvPair
                            })
                        }}
                        error={!!errorText}
                        helperText={errorText}
                />

                {user && <Box row padding={"20px"} center>

                    <Button
                            variant="outlined"
                            endIcon={<PersonAdd/>}
                            onClick={() => {
                                const inviteLink = createInviteLink(room, user.login_token);
                                utils.copyToClipboard(inviteLink).then(() => {
                                    notifier.success("Successfully copied an invite link to the clipboard.");
                                }).catch(notifier.error);
                            }}
                    >
                        Copy link
                    </Button>
                </Box>}

            </Box>

        </DialogContent>
        {!user && <DialogActions>
            <Button onClick={onClose}>Close</Button>
            <Button onClick={async () => {
                try {
                    const user: APIUser = await shadowClient.registerAnonymously(options.username);
                    setUser(user);
                    setErrortext("");
                } catch (e: any) {
                    setErrortext(e.message);
                }

            }}>Create user</Button>
        </DialogActions>}
    </Dialog>
}
